var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eq-container"},[_c('div',{staticClass:"eq-wrap"},[_c('div',{staticClass:"text-center"},[_c('b-img',{attrs:{"src":_vm.info.img,"fluid":""}})],1),_c('div',{staticClass:"eq-overlayer"},[_c('h3',[_vm._v(_vm._s(_vm.info.title))]),(_vm.desc)?_c('p',{staticClass:"mb-0",domProps:{"innerHTML":_vm._s(_vm.info.desc)}}):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }